import { ActiveSession } from '../personal-details/interfaces/personal-details.interfaces';
import { LoginSource } from '../personal-details/interfaces/personal-details.enum';

export class Session implements ActiveSession {
  device: string;
  login_date: number;
  ip_address: string;
  session_id: string;
  logout_date: number;
  status: boolean;
  access_type: number;

  constructor(session:ActiveSession) {
    this.device = session.device;
    this.login_date = session.login_date * 1000;
    this.ip_address = session.ip_address;
    this.session_id = session.session_id;
    this.logout_date = session.logout_date;
    this.access_type = session.access_type;
    if(this.logout_date === null || this.logout_date === undefined){
      this.status = true;
      this.logout_date = null;
    }else {
      this.status = false;
      this.logout_date =  this.logout_date * 1000;
    }
  }
}


/** Wire shape for auth/session events (matches backend JSON tags). */
export interface NewSession extends ActiveSession {
  client_id: string;
  login_source?: LoginSource;
  event: AuthEventType;
}

export interface BlackListedSession {
  session_id: string;
  event: string;
  logout_date: number;
}

export enum AuthEventType {
  NEW_SESSION = 'new_session',
  BLACKLISTED_SESSION = 'session_blacklisted',
}